import { useQuery } from 'react-apollo';
import { useSelector } from 'react-redux';

import { getSimplifiedAlbumMembershipGroupQuery } from '../../../../../../../../../temp/views/memberships/AlbumMembershipGroup/graphql/queries/getSimplifiedAlbumMembershipGroup';
import { getCheckoutCart } from '../../../../../../../../../../services/checkout/redux/checkoutSelectors';

const useSubscriptionIdentitySelect = ({ hierarchyItemId }) => {
  const cart = useSelector(state => getCheckoutCart(state));
  const { data: { albumMembershipGroup } = {} } = useQuery(
    getSimplifiedAlbumMembershipGroupQuery,
    {
      variables: {
        id: hierarchyItemId,
      },
      skip: !hierarchyItemId,
      fetchPolicy: 'cache-first',
    },
  );

  return {
    cart,
    albumMembershipGroup,
    identities: albumMembershipGroup?.identities ?? [],
  };
};

export default useSubscriptionIdentitySelect;
